/**
 * Takes a variety of object types and produces
 * links necessary to properly route the client side
 */

const resourcePaths = {
    blog: "posts",
    podcasts: "podcasts",
    "case-studies": "casestudies",
    "inside-sales-glossary": "glossary",
    infographics: "infographics",
    lp: "landingpages",
    embed: "embeddedpage",
    "thank-you": "thankyou",
    tools: "tools",
    webinars: "webinars",
    "sales-strategy": "resources",
    ebooks: "whitepapers",
    news: "news",
    revu: "videos",
    "revenue-exchange": "revenueexchange",
};

const replaceWPSiteWithFrontend = url => {
    return url.replace(process.env.WORDPRESS_URL, process.env.SITE_URL);
};

const replaceFrontendSiteWithWP = url => {
    return url.replace(process.env.SITE_URL, process.env.WORDPRESS_URL);
};

const getResourceSlugFromType = type => {
    return (Object.entries(resourcePaths).find(([_, v]) => v == type) || [])[0];
};

const getResourceSlugFromPath = path => {
    try {
        // Get the beginning route path
        // IE: `/blog/page/2` -> `blog`
        const chunks = path.split("/").slice(1);
        const slug = chunks[0];
        const tax = chunks.length > 1 ? chunks[1] : null;

        if (tax && slug === "blog") {
            switch (tax) {
                case "category":
                    return "categories";
                case "tag":
                    return "tags";
            }
        }

        return slug;
    } catch (e) {
        return null;
    }
};

const getResourceTypeFromPath = path => {
    const slug = getResourceSlugFromPath(path);

    if (["categories", "tags"].includes(slug)) return slug;

    if (!Object.prototype.hasOwnProperty.call(resourcePaths, slug)) return null;
    return resourcePaths[slug];
};

module.exports = {
    resourcePaths,
    getResourceSlugFromPath,
    getResourceTypeFromPath,
    getResourceSlugFromType,
    replaceWPSiteWithFrontend,
    replaceFrontendSiteWithWP
};
